import jwt_decode from "jwt-decode";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ResetPassword from "./components/pages/reset-password";
import UserProfile from "./components/pages/userProfile";
import VerifyUser from "./components/pages/verifyUser";
import ErrorRoutePage from "./components/Sections/ErrorRoutePage/ErrorRoutePage";
import LegalDisclaimer from "./components/Sections/LegalDisclaimer/LegalDisclaimer";
import PrivacyPolicy from "./components/Sections/PrivacyPolicy/PrivacyPolicy";
import ProgressBar from "./components/Sections/ProgressBar/ProgressBar";
import TermsCondition from "./components/Sections/TermsCondition/TermsCondition";
import Services from "./components/services/services";
// import PPFCalculator from "./components/resources/Calculators/PPF/PPFCalculator";
// import EmiCalculator from "./components/resources/Calculators/EmiCalculator/EmiCalculator";
// import TDScalculator from "./components/resources/Calculators/TDS/TDSCalculator";
// import TaxCalculator from "./components/resources/Calculators/personalIT/PersonalITCalculator";
// import MortgageCaclculator from "./components/resources/Calculators/Mortgage/MortgageCalculator";
const Homepage = lazy(() => import("./components/pages/homePage"));
const Login = lazy(() => import("./components/pages/login"));
const Register = lazy(() => import("./components/pages/register"));
const Dashboard = lazy(() => import("./components/pages/dashboard"));
const ForgotPassword = lazy(() => import("./components/pages/forgotpassword"));
const UserPage = lazy(() => import("./components/pages/userPage"));
const PPFCalculator = lazy(() =>
  import("./components/resources/Calculators/PPF/PPFCalculator")
);
const TDScalculator = lazy(() =>
  import("./components/resources/Calculators/TDS/TDSCalculator")
);
const TaxCalculator = lazy(() =>
  import("./components/resources/Calculators/personalIT/PersonalITCalculator")
);
const MortgageCaclculator = lazy(() =>
  import("./components/resources/Calculators/Mortgage/MortgageCalculator")
);

// this function is used as wrapper for other components while routing to
// handle lazy loading and routing
function Disclaimhandler(props) {
  // disc
  const [isaccepted, setisaccepted] = useState(false);

  return (
    <Suspense fallback={<ProgressBar />}>
      {localStorage.getItem("isaccepted") != null ||
      isaccepted ||
      sessionStorage.getItem("isaccepted") !== null ? (
        props.children
      ) : (
        <LegalDisclaimer setisaccepted={setisaccepted} />
      )}
    </Suspense>
  );
}

function App() {
  const [showModal, setShowModal] = useState(
    localStorage.getItem("modal") || sessionStorage.getItem("modal")
      ? false
      : true
  );

  if (sessionStorage.getItem("modal") || localStorage.getItem("modal")) {
    localStorage.setItem("modal", "1");
    sessionStorage.setItem("modal", "1");
  }

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("modal"); // triggers storage event
  });

  useEffect(() => {
    const token = localStorage.getItem("kss_token");
    if (token) {
      const decodedToken = jwt_decode(token, { complete: true });
      if (decodedToken.exp < Date.now() / 1000) {
        localStorage.removeItem("kss_token");
        window.alert("token expired please login again");
        window.location.reload();
      }
    }
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Disclaimhandler>
            <Homepage />
          </Disclaimhandler>
        </Route>{" "}
        <Route exact path="/legaldisclaimer" component={LegalDisclaimer} />{" "}
        <Route exact path="/login">
          <Disclaimhandler>
            <Homepage showModal={showModal} setShowModal={setShowModal} />
            <Login />
          </Disclaimhandler>
        </Route>
        <Route exact path="/register">
          <Disclaimhandler>
            <Homepage showModal={showModal} setShowModal={setShowModal} />
            <Register />
          </Disclaimhandler>
        </Route>
        <Route exact path="/dashboard">
          <Disclaimhandler>
            <Dashboard />
          </Disclaimhandler>
        </Route>
        <Route exact path="/forgotPassword">
          <Disclaimhandler>
            <Homepage showModal={showModal} setShowModal={setShowModal} />
            <ForgotPassword />
          </Disclaimhandler>
        </Route>
        <Route exact path="/userPage">
          <Disclaimhandler>
            <UserPage />
          </Disclaimhandler>
        </Route>
        <Route exact path="/userPage/profile">
          <Disclaimhandler>
            <UserProfile />
          </Disclaimhandler>
        </Route>
        <Route path="/resetPassword/:token" component={ResetPassword} />{" "}
        <Route path="/verifyUser/:token" component={VerifyUser} />{" "}
        <Route path="/resource/calculator/payroll/ppf">
          <Disclaimhandler>
            <PPFCalculator />
          </Disclaimhandler>
          {/* <PPFCalculator /> */}
        </Route>
        <Route path="/resource/calculator/incomeTax/tds">
          <Disclaimhandler>
            <TDScalculator />
          </Disclaimhandler>
          {/* <TDScalculator /> */}
        </Route>
        <Route path="/resource/calculator/incomeTax/personalIT">
          <Disclaimhandler>
            <TaxCalculator />
          </Disclaimhandler>
          {/* <TaxCalculator /> */}
        </Route>
        {/* Added code */}
        <Route path="/privacyPolicy">
          <PrivacyPolicy />
        </Route>
        <Route path="/termCondition">
          <TermsCondition></TermsCondition>
        </Route>
        <Route path="/resource/calculator/accounting/mortgage">
          <Disclaimhandler>
            <MortgageCaclculator />
          </Disclaimhandler>
          {/* <MortgageCaclculator /> */}
        </Route>
        <Route exact path="/service">
          <Disclaimhandler>
            <Services showModal={showModal} setShowModal={setShowModal} />
          </Disclaimhandler>
        </Route>{" "}
        <Route component={ErrorRoutePage} />
      </Switch>{" "}
    </Router>
  );
}

export default App;
